import { Step, withStepData } from "ui/organizms/Onboarding/Applications/common";
import useUBOIdentityVerification from "./useUBOIdentityVerification";
import { ECommerce } from "ui/forms/Onboarding";

const UBOIdentityVerification = () => {
    const uboIdentityVerification = useUBOIdentityVerification();

    return (
        <Step
            title='UBO Identity Verification'
        >
            <ECommerce.UBOIdentityVerification.Form
                {...uboIdentityVerification}
            />
        </Step>
    );
};

export default withStepData(UBOIdentityVerification);
